'use strict';
import bus from 'kernel/messagebus/MessageBus';
import { consoleConfig, serverConfig } from 'kernel/clientconfig/ClientConfig';
//Todo, this should actually be the resizer.  Half of it is on

/**
 * @module resizer/Resizer
 * @memberof kernel
 * @description Handles the resizing of iframes on the Skateboard Stack
 * @example
 * var Resizer = require("kernel/resizer/Resizer");
 * Resizer.init({
 *     bus: wrappedBus,
 *     config: {
 *     	dragNotifyTime : 1000 //0 for 'off'
 *      container: <ref>,
 *      iframes: {
 *     		Game: <ref>,
 *     		Splash: <ref>,
 *     		TConsoleView: <ref>,
 *     		LConsoleView: <ref>,
 *     		RConsoleView: <ref>,
 *     		BConsoleView: <ref>,
 *     		SizingConfig: {
 *     			GameOverlap: {
 *     				top:'0px'
 *     			}
 *     		}
 *     	}
 * });
 *
 */

/*
 * Things That Are Known
 * Using a/A in iOS Safari does not trigger a resize event.  To know if this happened we need to check visualViewport
 * The 'scroll' window event will tell us if a pinch zoom is occurring
 *
 */


	var inited=false; //Sanity trapper
	var config;

	var cecCommand;

	function setStyles(element, styles) {
		Object.keys(styles).forEach(function(styleRef) {
			element.style[styleRef] = styles[styleRef];
		});
	}

	//First, set the document html + body setup
	function initialiseCSS() {
		setStyles(windowRef.document.getElementsByTagName('html')[0], {
			width:'100%'//,
			//height:'calc(100vh + 1px)',
			//height:'100%'//,
			//overflow:'hidden' //THIS PART BREAKS MOBILE
		}); /* This CSS should ALREADY exist. */
		setStyles(windowRef.document.getElementsByTagName('body')[0], {
			width:'100%',
			//width:'calc(100% - env(safe-area-inset-left) - env(safe-area-inset-right) - constant(safe-area-inset-left) - constant(safe-area-inset-right))',
			//height:'calc(100vh + 50px)',
			//overflow:'hidden',
			height:'100%',
			boxSizing: 'border-box'
		});
	}

	function lockWindowCSS(forcedWidthCSS, forcedHeightCSS) { //SKATE-1696
		setStyles(windowRef.document.getElementsByTagName('html')[0], {
			width:forcedWidthCSS,
			height:forcedHeightCSS,
			overflow:'hidden'
		});
		setStyles(windowRef.document.getElementsByTagName('body')[0], {
			width:forcedWidthCSS,
			height:forcedHeightCSS,
			boxSizing: 'border-box'
		});
	}

	//Third, set the CSS on the container
	function setContainerCSS(element) {
		setStyles(element, {
			position:'fixed', //Fix for anchor links scrolling the game window
			bottom:'0', //SKATE-6559 - avoid ios scrolling by positioning against *bottom*
			left:'0',
			width:'100%',
			height:'100%',
			touchAction:'pan-y' /* SKATE-6556 */
		});
	}

	//Then setup resizer functions

/**
 * @function resizer
 * @description subsystem resize handler for platform
 * @private
 * @instance
 * @fires Kernel.System.Resize
 * This should be moved to its own module!
 */
var fullscreenFlag = false;
var resizerHandle;
var overrideGamePositioningFromWidget;
var lastZoomLevel;
var bypassZoomFix;

// SKATE-2498:  Game not resizing in iFrame when testing in mobile mode
var zoomBlock = false;
var gameReady = false;

//Imported from SubsystemManager - SKATE-6458
var gameLoadComplete = false;

var iOSBarWorkaround = (window.parent === window && window.navigator.userAgent.indexOf('iPhone') >= 0); //only iphone, only non iframe //SKATE-4602
var sizesDirty = true;
var lastWindow = {
	width:0,
	height:0,
	TCustomViewHeight:0,
	BCustomViewHeight:0,
	LCustomViewWidth:0,
	RCustomViewWidth:0
};

var LCustomViewWidth=0,RCustomViewWidth=0,TCustomViewHeight=0,BCustomViewHeight=0,GameTopOffset=0;
var forceWidth, forceHeight; //SKATE-1696, force sizes

var defaultConsoleOverflow = 'hidden';

var consoleFrameData;
function updateFrameSizes(data) {
	consoleFrameData = data;
	sizesDirty=true; //Maybe check if the console frame data actually changed first?
	resizer();
}

/**
 * @function recalculateLayout
 * @description helper method for re-applying style/size css
 * @private
 * @instance
 * @returns {object} The recalculated layout configuration object
 */
function recalculateLayout(customViews){
	//Calculate widths based on Config
	LCustomViewWidth = (consoleConfig.LCustomView && consoleConfig.LCustomView.width) ? Math.ceil(parseInt(consoleConfig.LCustomView.width)) : 0;
	RCustomViewWidth = (consoleConfig.RCustomView && consoleConfig.RCustomView.width) ? Math.ceil(parseInt(consoleConfig.RCustomView.width)) : 0;
	TCustomViewHeight = (consoleConfig.TCustomView && consoleConfig.TCustomView.height) ? Math.ceil(parseInt(consoleConfig.TCustomView.height)) : 0;
	BCustomViewHeight = (consoleConfig.BCustomView && consoleConfig.BCustomView.height) ? Math.ceil(parseInt(consoleConfig.BCustomView.height)) : 0;

	//TODO - Somehow expose the re-calculated reservedSize from the consoles as set in MXFAdapter

	// Make a special case for top console, as in mobile the game will sit flush with top of screen
	// Note: this may not be required any longer, as the new height reservation API should take care of this for Desktop

	//The following line for SKATE-896 locks the top to the pre-defined console height.
	GameTopOffset = !gameReady?0:(consoleConfig.TCustomView && (consoleConfig.TCustomView.resizable==='Y' || consoleConfig.TCustomView.resizable==='true')) ? 0 : TCustomViewHeight;
	//TODO - Any Reserved Size needs to be added to GameTopOffset
	//SKATE-5303 - Set GameTopOffset to 0 during load when splash is not yet revealed
	if (consoleFrameData) {
		LCustomViewWidth = consoleFrameData.LCustomView.reserved || LCustomViewWidth;
		RCustomViewWidth = consoleFrameData.RCustomView.reserved || RCustomViewWidth;
		TCustomViewHeight = consoleFrameData.TCustomView.reserved || TCustomViewHeight;
		BCustomViewHeight = consoleFrameData.BCustomView.reserved || BCustomViewHeight;
		GameTopOffset = !gameReady?0:consoleConfig.TCustomView && (consoleConfig.TCustomView.resizable==='Y'|| consoleConfig.TCustomView.resizable==='true') && !consoleFrameData.TCustomView.reserved ? 0 : TCustomViewHeight; //SKATE-1634
	}

	//Store data in size tracker
	lastWindow.TCustomViewHeight = TCustomViewHeight;
	lastWindow.BCustomViewHeight = BCustomViewHeight;
	lastWindow.LCustomViewWidth = LCustomViewWidth;
	lastWindow.RCustomViewWidth = RCustomViewWidth;
	lastWindow.GameTopOffset = GameTopOffset;

	//SKATE-878 - make console scrollable if 'open' and resizable
	return { //SKATE-906 - This component doesn't need to resize the frames at all!
		TCustomView:{
			position:'absolute',
			width:'100%',
			top:0,
			transform:'translateZ(0)',
			overflow:defaultConsoleOverflow,
			webkitOverflowScrolling: 'touch',
			zIndex:8,
			transitionDelay:'20ms', //BJSIW-82 and others - fix for iOS not revealing consoles correctly
			transitionProperty:'height'
		},
		LCustomView:{
			position:'absolute',
			left:0,
			top:0 + TCustomViewHeight + "px",
			bottom:0 + BCustomViewHeight + "px",
			//width:LCustomViewWidth + "px",
			height:window.innerHeight - (TCustomViewHeight + BCustomViewHeight) + "px",
			transform:'translateZ(0)',
			overflow:defaultConsoleOverflow,
			webkitOverflowScrolling: 'touch',
			transitionDelay:'20ms',
			transitionProperty:'width',
			zIndex:6
		},
		BCustomView:{
			position:'absolute',
			bottom:0,
			width:'100%',
			//height:BCustomViewHeight + "px",
			transform:'translateZ(0)',
			overflow:defaultConsoleOverflow,
			webkitOverflowScrolling: 'touch',
			zIndex:7,
			transitionDelay:'20ms',
			transitionProperty:'height'
		},
		RCustomView:{
			position:'absolute',
			right:0,
			top:0 + TCustomViewHeight + "px",
			bottom:0 + BCustomViewHeight + "px",
			//width:RCustomViewWidth + "px",
			height:window.innerHeight - (TCustomViewHeight + BCustomViewHeight) + "px",
			transform:'translateZ(0)',
			overflow:defaultConsoleOverflow,
			webkitOverflowScrolling: 'touch',
			transitionDelay:'20ms',
			transitionProperty:'width',
			zIndex:5
		}
	};
}

function overrideResizer(data) { //SKATE-1696
	forceWidth = data.width;
	forceHeight = data.height;
	resizer();
}

var initDone = false;
var requested=false;
function resizer() {
	if(!requested) {
		requested = true;
		requestAnimationFrame(processResizer); //Push onto the next animation frame, to avoid any strange invalidation that happens
	}

}

function processResizer(){
	requested = false;
	if (!inited) {
		return; //Can't resize before init
	}
//	if (!resizerHandle) {
//		resizerHandle = setInterval(function(){requestAnimationFrame(resizer);},1000); //Trigger a rAF call every second to verify.  No invalidation.
//	}

	var sizeReport = {}; //Added to System.Resize - information on size of all related components

	//TODO - in the future zoomLevel could be reinstated using window.visualViewport.scale
	var zoomLevel = zoomBlock?(window.outerWidth ? window.outerWidth / window.innerWidth : 1):1; //No outer, no zoom calculation
	if (zoomLevel !== lastZoomLevel) {
		sizesDirty = true;
	}

	//TODO - investigate: in our current setup this doesn't always seem to do anything?
	if (window.scrollX !== 0) {
		//window.scrollTo(0, window.scrollY);
		window.scrollTo(0, navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.match(/\s+8_[\d_]+\s+like Mac OS X/) ? 1 : 0);
	}

	// Check if dimensions have changed since the last resize event, to reduce unneccessary restyling logic
	//validate if size changed by tracking window size - this part is fine, doesn't matter about the margin at this point
	var realWidth = forceWidth?forceWidth:window.visualViewport?window.visualViewport.width:window.innerWidth;
	var realHeight = forceHeight?forceHeight:window.visualViewport?window.visualViewport.height:window.innerHeight;

	if(!sizesDirty && realWidth === lastWindow.width && realHeight === lastWindow.height) {
		return;
	}
	lastWindow.width = realWidth;
	lastWindow.height = realHeight;

	//TODO - check if the CEC code should be triggered on a different process
	// JS is *sort of* single-threaded, so if
	if ((window.fullScreen) || (window.screen.height === window.innerHeight && window.screen.width === window.innerWidth)) {
		if (!fullscreenFlag) {//There's a way to determine if fullscreen other than this - using document.fullscreen, for example
			fullscreenFlag = true;
			if(cecCommand){
				cecCommand.postFullscreenEvent("E");
			}
		}

	} else {
		if (fullscreenFlag) {
			fullscreenFlag = false;
			if(cecCommand){
				cecCommand.postFullscreenEvent("D");
			}
		}
	}

	sizesDirty = false;
	//config.container.style.height = window.innerHeight + 'px'; //Fix SKATE-734
	//Need to verify edge cases for broken reading of window.screen.height - S4 for example.
	var bodyCalc = window.getComputedStyle(document.body); //The padding value curiously will actually go wrong when pinch-zooming.  Congrats, Apple.
	var iosBarOffset = 0;
	//SKATE-4602 - if there's a good chance that there is a white bar onscreen, we allow for it
	if (iOSBarWorkaround &&												//iOS & not in iframe
		(!bodyCalc.paddingBottom || bodyCalc.paddingBottom==='0px')	//If there is 'no' bottom padding apparently set
	) {
		//(realWidth > realHeight)) {										//If Landscape
		var outerSpace = window.outerHeight - window.innerHeight; 	//In some instances window.outerHeight is actually the width until after rotate
		if ((outerSpace > 0 && outerSpace < 25) || 					//If we have all the screen, except the thin URL bar, we're probably fullscreen.  Ish.
			(document.body.offsetHeight > window.innerHeight)) {
			//ios has hidden toolbars
			if (realWidth > realHeight) {
				iosBarOffset = 21;
			} else {
				iosBarOffset = 34;
			}
		}
		realHeight -= iosBarOffset;
	}

	//if iOS?  or if mobile?
	if (zoomLevel !== lastZoomLevel) {
		if (zoomLevel > 1) {
			config.container.style.webkitTransformOrigin = '0 0';
			config.container.style.webkitTransform = 'scale(' + (1 / zoomLevel) + ')';
			realWidth = realWidth * zoomLevel;
			realHeight = realHeight * zoomLevel;
		} else {
			config.container.style.webkitTransform = '';
		}
	}
	lastZoomLevel = zoomLevel;
	if (window.parent === window) { //check for padding
		//config.container.style.height = 'calc('+window.innerHeight+'px - '+(bodyCalc.paddingBottom)+' - '+bodyCalc.paddingTop+')';
		//config.container.style.width = 'calc('+window.innerWidth+'px - '+(bodyCalc.paddingLeft)+' - '+bodyCalc.paddingRight+')';
		config.container.style.position = 'fixed';//'absolute'; //'fixed'; //SKATE-3712
//			config.container.style.top = 'calc(0px + env(safe-area-inset-top) + constant(safe-area-inset-top))';
//			config.container.style.left = 'calc((env(safe-area-inset-left) / '+zoomLevel+') + (constant(safe-area-inset-left) / '+zoomLevel+'))';
		//config.container.style.top = 'calc(0px + ('+bodyCalc.paddingTop+' / '+zoomLevel+'))';
		config.container.style.bottom = 'calc(0px + ('+bodyCalc.paddingBottom+' / '+zoomLevel+') + '+iosBarOffset+'px)';
		config.container.style.left = 'calc(0px + ('+bodyCalc.paddingLeft+' / '+zoomLevel+'))';

		config.container.style.width = 'calc('+realWidth+'px - '+(bodyCalc.paddingLeft)+' - '+(bodyCalc.paddingRight)+')';
		config.container.style.height = 'calc('+realHeight+'px - '+(bodyCalc.paddingBottom)+' - '+bodyCalc.paddingTop+')';
	} else { //don't check for padding on container, it's not our problem
		//config.container.style.height = window.innerHeight+'px';
		//config.container.style.width = window.innerWidth+'px';
		config.container.style.width = '100%'; //SKATE-1625
		config.container.style.height = '100%';		}
	//SKATE-1574, SKATE-1571
	//After resizing we have to scroll to top
	var scrollTopFunc = function() {
		window.scrollTo(0, navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.match(/\s+8_[\d_]+\s+like Mac OS X/) ? 1 : 0);
	};
	scrollTopFunc();
	// reset the layout config for console frames
	var layout = recalculateLayout(config.customViews);

	// Apply the recalculated layout styles for the custom console views
	/* */

	//if (consoleFrameData) { //If there are console resizes, reapply here.
		for (var view in config.customViews) { //disabling this for now
			setStyles(config.customViews[view], layout[view]);
		}
	//}
	/* */
	// Resize the splash frame element (if available)
	//on iphone-x this will result in full-screen splash.
	if(config.splashframe && config.splashContainer){
		setStyles(config.splashContainer,{
			position:"absolute",
			left:"0px",
			top:"0px",
			width:config.container.offsetWidth + "px",
			height:config.container.offsetHeight + "px"
		});
	}


	//To recap this function's purpose - the console should now be responsible for resizing its iframes, as it's the only place that has that understanding
	//This part will just adjust the game frame

	// Temporary fix for misconfigured custom view config (if mobile console & resizable & height value > 0)
	//if(consoleConfig.TCustomView.resizable==='Y'){ //No longer required
	//	TCustomViewHeight = 0;
	//}

	if (config.widgetContainer) {
		setStyles(config.widgetContainer, {
			position: "absolute",
			left: LCustomViewWidth + "px",
			top: GameTopOffset + "px",
			bottom: BCustomViewHeight + "px",
			width: config.container.offsetWidth - (LCustomViewWidth + RCustomViewWidth) + "px",
			height: config.container.offsetHeight - (GameTopOffset + BCustomViewHeight) + "px"
		});
	}

	//first set overall container size from widget
	//then apply sizing from GSP, otherwise apply normal sizing
	if (overrideGamePositioningFromWidget) {
		setStyles(config.gameContainer, {
			position:"absolute",
			left:(LCustomViewWidth + overrideGamePositioningFromWidget.left)+'px', //SKATE-2766
			top:(GameTopOffset+overrideGamePositioningFromWidget.top)+'px',
			width:overrideGamePositioningFromWidget.width+'px',
			height:overrideGamePositioningFromWidget.height+'px'
		});
	} else {
		setStyles(config.gameContainer, {
			position: "absolute",
			left: LCustomViewWidth + "px",
			top: GameTopOffset + "px",
			bottom: BCustomViewHeight + "px",
			width: config.container.offsetWidth - (LCustomViewWidth + RCustomViewWidth) + "px",
			height: config.container.offsetHeight - (GameTopOffset + BCustomViewHeight) + "px"
		});
	}
	if (overrideGamePositioningFromWidget) {
		setStyles(config.gameframe.element, {
			position:"absolute",
			left:'0px',
			top:'0px',
			width:overrideGamePositioningFromWidget.width+'px',
			height:overrideGamePositioningFromWidget.height+'px'
		});
		sizeReport.game = {
			left:overrideGamePositioningFromWidget.left,
			top:(GameTopOffset+overrideGamePositioningFromWidget.top),
			width:overrideGamePositioningFromWidget.width,
			height:overrideGamePositioningFromWidget.height
		};
	} else {
		sizeReport.game = {
			left: LCustomViewWidth,
			top: GameTopOffset,
			width: config.container.offsetWidth - (LCustomViewWidth + RCustomViewWidth),
			height: config.container.offsetHeight - (GameTopOffset + BCustomViewHeight)
		};
	}

	config.gameframe.element.style.width='100%';    //SKATE-1994 this is safe enough to trigger a reflow in broken
	config.gameframe.element.style.width='inherit'; //				Chrome 74+75 *and* not break iOS browsers

	config.gameframe.element.style.height='100%';
	config.gameframe.element.style.width='inherit'; //				Chrome 74+75 *and* not break iOS browsers
	config.gameframe.element.style.height='inherit';
	//SKATE-5036 - note to self, do we even bother with the containers?  We're basically overwriting the config.gameframe.element.style so...why?

	// Notify Subscribers there has been a resize change (or orientation change)
	bus.publish({channel:"Kernel",topic:"System.Resize",data:sizeReport});
}

	//Then init dragging

	var windowRef;

	/**
	 * @function init
	 * @description Initialize the resizer
	 * @param config {InitConfig}
	 */
	function init(initConfig, _window){
		if(inited){
			return;
		}

		windowRef = _window || window;

		if(!initConfig){
			throw new Error("Initialize config data required for Resizer initialization");
		}

		config = initConfig.config;
		//Initialise all the things
		initialiseCSS();

		setContainerCSS(config.container);
		if (serverConfig.channel !== "INT") {
			defaultConsoleOverflow = 'scroll';
		}
		// Keep wrapped bus if it is provided
		if('bus' in initConfig && initConfig['bus'] !== null){
			//bus = initConfig.bus;
			// Subscribe Logging Topic
			bus.subscribe({ //Not even sure if this is a thing?
				channel: 'Kernel',
				topic: 'Resizer.#',
				callback: function(data, envelope){

					//Do Resizing

					//Reply
					envelope.reply(null, {result: 'done'});
				}
			});
			bus.subscribe({ //PSU Support, SKATE-1696
				channel: 'ConsoleService',
				topic: 'Option.SetSize',
				callback: function (data) {
					var CSSWidth = Number(data.width)+'px'; //Force pixel values?
					var CSSHeight = Number(data.height)+'px';
					lockWindowCSS(CSSWidth, CSSHeight);
					overrideResizer(data);
				}
			});
			bus.subscribe({channel: 'ConsoleService', topic: 'Option.disableIOSBarFix', callback: function(data) {
				iOSBarWorkaround = false;
			}});
			bus.subscribe({channel: 'ConsoleService', topic: 'ConsoleService.Resize', callback: updateFrameSizes}); //SKATE-1012 - this needs to be set to listen much earlier
			bus.subscribe({
				channel: 'GameService',
				topic: 'Widget.PositionGame',
				callback: function(positionData) {
					if (!positionData) { //Widget.PositionGame with no data removes the ovveride
						overrideGamePositioningFromWidget = void(0);
						sizesDirty = true;
						resizer();
					} else if (positionData.game && gameLoadComplete) {
						if (!overrideGamePositioningFromWidget ||
							(overrideGamePositioningFromWidget.left !== positionData.game.left || overrideGamePositioningFromWidget.top !== positionData.game.top ||
								overrideGamePositioningFromWidget.width !== positionData.game.width || overrideGamePositioningFromWidget.height !== positionData.game.height ||
								overrideGamePositioningFromWidget.z !== positionData.game.z)) {
							overrideGamePositioningFromWidget = positionData.game;
							//if (gameservicepanel && overrideGamePositioning.hasOwnProperty('z')) {
							//	config.gameContainer.style.zIndex = overrideGamePositioning.z;
							//}
							sizesDirty = true;
							resizer();
						}
					}
				}
			});
			bus.subscribe({channel:"Kernel", topic:"System.Init", callback: function(data) {
					gameLoadComplete = true;
					gameReady = true;
					sizesDirty=true; //We need to apply this for a resize :)  Otherwise games are under desktop consoles.
					resizer();
				}
			});

			var blockedTracking = {}; //Track
			bus.subscribe({channel:"Kernel", topic:"BlockGame", callback:function(blockRequest) {
				if (config.gameBlocker) {
					var ifBlock = false;
					if (blockRequest?.from) {
						blockedTracking[blockRequest.from] = !!blockRequest.block;
					} else {
						ifBlock = !!blockRequest; //No 'from', so it's a global on / off
						if (!ifBlock) { //Global block false, remove all other blocks
							blockedTracking = {};
						} else {
							blockedTracking.Kernel = true;
							//We need this, otherwise widgets turning on + off could unblock a master 'on'
						}
					}
					Object.keys(blockedTracking).forEach(function(fromComponent){
						ifBlock = ifBlock || blockedTracking[fromComponent];
					});

					if (ifBlock) {
						config.gameBlocker.style.visibility = 'visible';
						/* devblock:start */
						config.gameBlocker.style.backgroundColor='rgba(255,0,0,0.3)';
						//This is temporary, just to make it visible.  Dev builds ONLY
						/* devblock:end */
					} else {
						config.gameBlocker.style.visibility = 'hidden';
						blockedTracking = {}; //All blockers removed, turn it off.
					}
				}
			}});

		}

		/*
		NOTE! IF A PARENT FRAME EXECUTES event.stopImmediatePropagation() ON THE RESIZE EVENT
		THE PLATFORM WILL NOT RECEIVE A RESIZE EVENT.  We SHOULD, however receive a viewport change event.
		This at least should save us some problems.
		TODO: Investigate this with an iframe container.  We've seen it in staging / prod.
		 */
		function forceResize() {
			sizesDirty=true;
			resizer();
		}
		window.addEventListener('resize', forceResize);

		screen.orientation.addEventListener('change',forceResize);

		//The following two are for when pinch zoom or menu text increase / decrease (aA) occurs
		//  A the scale of the viewport may change, it could be worth changing the touch-action to 'auto' until the
		//  scale is back at 1 - at which point we swap back to pan-y.  Unfortunately there is no programatic way to
		//  revert that scale that is controlled by the user.  We can, at least, ensure the zooming is user-controllable
		//  until the point at which they zoom back out.

		// viewport scroll occurs when the page itself scrolls - physically moving.  This happens during a pinch-zoom
		//   as the page is moving about.  We can use this to determine a zoom happened.  We can also use this to
		//   disable pinch-zoom blocking until the scale is back at 1
		window.visualViewport.addEventListener('scroll', resizer);
		//forcing the resize will trigger scroll forever in cases where the page gets scrolled up by the resizer
		//Pinch zoom - THIS IS A PROBLEM AS SCROLL IS TRIGGERED BY FORCERESIZE :D

		// viewport resize occurs whenever the viewport itself resizes - also during pinch zoom (though not always as
		//   frequently / reliably).  It also occurs when the user uses a browser control to enlarge / reduce text.
		//   The text sizing actually just zooms the viewport in / out.  This event will allow us to detect that change
		//   and trigger a resize update.
		window.visualViewport.addEventListener('resize', forceResize); //Menu zoom/scale

		//TODO: Add using pointer-events:none to pass through clicks on any experimental pinch zoom blockers
		//touch-action, manipulation allows pinch zoom but should disable double tap zoom
		//pan-y is the default preference for most things, it stops pinch zooming and defaults to the console being
		//scrollable.

		//TODO: Possible thrashing blocker?  If pinch zoom happens, every frame will be a resizer check.
		//We could possibly add a feature where if resize happened twice in the last 0.5 seconds we wait a second
		// before honouring the next resize.  That way we won't get 60 resizes per second while pinch zooming - we
		// just get 2.  Currently the resizer is limited to framerate - triggering forceResize internally just requests
		// the next animation frame, then triggers the resizer update flow.  If already pending a RAF repaint we don't
		// re-request.  We just wait for the next update to happen.

		inited = true;
	}

    function setCECCommand(cmd) {
    	cecCommand = cmd;
    }

	//Notify that we need to kill the game frame
	function killGameFrame() {
		if (config?.gameframe?.element) {
			config.gameContainer.removeChild(config.gameframe.element);
			config.gameframe.element = document.createElement('div'); //Stop any weird crashes.
			config.gameframe.element.style.visiblilty = 'hidden';
		}
	}


	/**
	 * @function resizer
	 * @description The function returns a singleton object for expose logging functionalities
	 * @private
	 * @return {object}
	 */
	function resizerExport(){

		return Object.freeze({
			// Package level
			init: init,
			setCECCommand:setCECCommand,
			resizer:resizer,
			recalculateLayout:recalculateLayout,
			removeGameFrame:killGameFrame,
			getLastWindow : function(){return lastWindow;}
		});
	}


	export default resizerExport();

//});

//Things of note
//1) on iOS when we are using the workaround. 21px in landscape, 34px in portrait
//2) on iOS when hiding toolbars in certain setups the viewport is fullscreen as ui elements now float, and games slide up
//   To fix this, we have to position bottom:0, not top:<value>
//3) iOS is annoying